import { request } from '@/request/request';
import { parameterChange } from '@/utils';

export default {
  getDict(dictType) {
    return request({
      url: `${process.env.VUE_APP_BIN_PREFIX}/system/dict/data/type/${dictType}`,
      method: 'get',
    });
  },
  // 字典列表
  dictList(data) {
    return request({
      url: `${process.env.VUE_APP_BIN_PREFIX}/system/dict/type/list?pageNum=1&pageSize=999&dictType=cohf`,
      method: 'get',
    });
  },
  // 字典更新
  dictUpdate(data) {
    return request({
      url: `${process.env.VUE_APP_GU_PREFIX}/dict/update`,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      method: 'post',
      data,
    });
  },
  // 字典详情
  dictDetails(data) {
    return request({
      url: `${process.env.VUE_APP_GU_PREFIX}/dict/details?${parameterChange(data)}`,
      method: 'get',
    });
  },
  // 字典新增
  dictAdd(data) {
    return request({
      url: `${process.env.VUE_APP_GU_PREFIX}/dict/add`,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      method: 'post',
      data,
    });
  },
  // 字典删除
  dictDelete(data) {
    return request({
      url: `${process.env.VUE_APP_GU_PREFIX}/dict/delete?${parameterChange(data)}`,
      method: 'delete',
    });
  },
};
